module.exports = __webpack_public_path__ + "static/media/Slide22.ea358d02.JPG";